define(function (require) {
    'use strict';

    var LE = require('app');
    var LEConfig = require("assets/config/le-env-conf");
    var BaseRouterController = require("controllers/BaseRouterController");

    var DataSourcesTabsController = require("manager-controllers/DataSourcesTabsController");
    var ApiKeyEditController = require("manager-controllers/data-sources/api-keys/ApiKeyEditController");
    var AppKeysGalleryController = require("manager-controllers/data-sources/integrations/app-keys/AppKeysGalleryController");
    var AppKeyEditController = require("manager-controllers/data-sources/integrations/app-keys/AppKeyEditController");
    var AuthenticationServerController = require("manager-controllers/data-sources/integrations/authentication/AuthenticationServerController");

    var DataSourcesSdesController = require("manager-controllers/DataSourcesSdesController");

    var LanguageSettingsController = require("manager-controllers/LanguageSettingsController");
    var CategoriesTableController = require("manager-controllers/CategoriesTableController");
    var ShiftStatusController = require("manager-controllers/ShiftStatusController");
    var LPTagController = require("manager-controllers/LPTagController");
    var ManageDomainsController = require("manager-controllers/ManageDomainsController");

    var MyProfileController = require("manager-controllers/MyProfileController");
    var AuditTrailController = require("manager-controllers/AuditTrailController");
    var AppInstallEditController = require("manager-controllers/data-sources/app-install/AppInstallEditController");
    var FacebookController = require("manager-controllers/data-sources/conversation-sources/types/FacebookController");
    var TwilioController = require("manager-controllers/data-sources/conversation-sources/types/TwilioController");
    var BrandAppController = require("manager-controllers/data-sources/conversation-sources/types/BrandAppController");

    var ScheduleController = require("manager-controllers/ScheduleController");
    var SpecialOccasionController = require("manager-controllers/SpecialOccasionController");

    var ManagerRouteController = {};
    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {

        ManagerRouteController = BaseRouterController.extend({
            navigation:{
                routes:{
                    "data/integrations": {
                        callback: "showDataSourcesIntegrationsTab",
                        name: "DataSourcesOpen",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.LE_VIEW_CAMPAIGN_MODULE]
                        }
                    },
                    "data/apiKeys": {
                        callback: "showDataSourcesApiTab",
                        name: "DataSourcesOpen",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.VIEW_API_KEYS_MANAGEMENT]
                        }
                    },
                    "data/apiKeys/:id": {
                        callback: "showApiKeyEdit",
                        name: "showApiKeyGalleryItem",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.VIEW_API_KEYS_MANAGEMENT]
                        }
                    },
                    "data/apiKeys/new": {
                        callback: "showApiKeyEditNew",
                        name: "showApiKeyGalleryItem",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.EDIT_API_KEYS_MANAGEMENT]
                        }
                    },
                    "data/integrations/appKeys": {
                        callback: "showAppKeysGallery",
                        name: "DataSourcesMobileOpen",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.AC_APPLICATION_READ]
                        }
                    },
                    "data/integrations/appKeys/:id": {
                        callback: "showAppKeyEdit",
                        name: "dataSourcesAppKeyConfig",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.AC_APPLICATION_EDIT]
                        }
                    },

                    "data/integrations/cat/:id": {
                        callback: "configureDataSource",
                        name: "ConfigureDataSource",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.EDIT_ENGAGEMENT_ATTRIBUTES]
                        }
                    },
                    "data/integrations/sde/:id": {
                        callback: "configureDataSourcesAttribute",
                        name: "ConfigureDataSourcesAttribute",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.EDIT_ENGAGEMENT_ATTRIBUTES]
                        }
                    },
                    "languages/edit": {
                        callback: "languagesSettingsOpen",
                        name: "LanguagesSettingsOpen",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.EDIT_CANNED, LE.sessionManager.PRIVILEGES.ADD_CANNED, LE.sessionManager.PRIVILEGES.EDIT_SYSTEM_MESSAGES, LE.sessionManager.PRIVILEGES.LE_EDIT_CAMPAIGNS]
                        }
                    },
                    "categories": {
                        callback: "categoriesOpen",
                        name: "CategoriesOpen",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.LE_VIEW_CAMPAIGN_MODULE]
                        }
                    },
                    "lptag": {
                        callback: "lptagOpen",
                        name: "LptagOpen",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.LE_VIEW_CAMPAIGN_MODULE, LE.sessionManager.PRIVILEGES.LE_VIEW_USER_MANAGEMENT_MODULE]
                        }
                    },
                    "manageDomains": {
                        callback: "manageDomainsOpen",
                        name: "ManageDomainsOpen",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.EDIT_REFERER_RESTRICTIONS]
                        }
                    },
                    "myProfile"       :   {
                        callback: "myProfileOpen",
                        name: "MyProfileOpen",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.CHANGE_MY_DETAILS]
                        }
                    },
                    "shiftStatus"       :   {
                        callback: "showShiftStatus",
                        name: "ShiftStatusOpen",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.CONFIGURE_SHIFT_STATUS]
                        }
                    },
                    "shiftStatus/schedules": {
                        callback: "showScheduleGalleryShiftStatus",
                        name: "ShiftStatusOpen",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.CONFIGURE_SHIFT_STATUS]
                        }
                    },
                    "shiftStatus/schedules/select/:scheduleId": {
                        callback: "showScheduleGalleryShiftStatusSelect",
                        name: "ShiftStatusOpen",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.CONFIGURE_SHIFT_STATUS]
                        }
                    },
                    "shiftStatus/schedules/edit/:scheduleId": {
                        callback: "showScheduleEditShiftStatus",
                        name: "ShiftStatusOpen",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.CONFIGURE_SHIFT_STATUS]
                        }
                    },
                    "shiftStatus/schedules/edit/new": {
                        callback: "showScheduleNewShiftStatus",
                        name: "ShiftStatusOpen",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.CONFIGURE_SHIFT_STATUS]
                        }
                    },
                    "shiftStatus/specialOccasions": {
                        callback: "showSpecialOccasionGalleryShiftStatus",
                        name: "ShiftStatusOpen",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.CONFIGURE_SHIFT_STATUS]
                        }
                    },
                    "shiftStatus/specialOccasions/select/:specialOccasionId": {
                        callback: "showSpecialOccasionGalleryShiftStatusSelect",
                        name: "ShiftStatusOpen",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.CONFIGURE_SHIFT_STATUS]
                        }
                    },
                    "shiftStatus/specialOccasions/edit/:specialOccasionId": {
                        callback: "showSpecialOccasionEditShiftStatus",
                        name: "ShiftStatusOpen",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.CONFIGURE_SHIFT_STATUS]
                        }
                    },
                    "shiftStatus/specialOccasions/edit/new": {
                        callback: "showSpecialOccasionNewShiftStatus",
                        name: "ShiftStatusOpen",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.CONFIGURE_SHIFT_STATUS]
                        }
                    },



                    "skills/:skillId/schedules": {
                        callback: "showScheduleGallerySkill",
                        name: "EditSkill",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.EDIT_AC_USERS_SKILLS]
                        }
                    },
                    "skills/:skillId/schedules/select/:scheduleId": {
                        callback: "showScheduleGallerySkillSelect",
                        name: "EditSkill",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.EDIT_AC_USERS_SKILLS]
                        }
                    },
                    "skills/:skillId/schedules/edit/:scheduleId": {
                        callback: "showScheduleEditSkill",
                        name: "EditSkill",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.EDIT_AC_USERS_SKILLS]
                        }
                    },
                    "skills/:skillId/schedules/edit/new": {
                        callback: "showScheduleNewSkill",
                        name: "EditSkill",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.EDIT_AC_USERS_SKILLS]
                        }
                    },
                    "skills/:skillId/specialOccasions": {
                        callback: "showSpecialOccasionGallerySkill",
                        name: "EditSkill",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.EDIT_AC_USERS_SKILLS]
                        }
                    },
                    "skills/:skillId/specialOccasions/select/:specialOccasionId": {
                        callback: "showSpecialOccasionGallerySkillSelect",
                        name: "EditSkill",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.EDIT_AC_USERS_SKILLS]
                        }
                    },
                    "skills/:skillId/specialOccasions/edit/:specialOccasionId": {
                        callback: "showSpecialOccasionEditSkill",
                        name: "EditSkill",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.EDIT_AC_USERS_SKILLS]
                        }
                    },
                    "skills/:skillId/specialOccasions/edit/new": {
                        callback: "showSpecialOccasionNewSkill",
                        name: "EditSkill",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.EDIT_AC_USERS_SKILLS]
                        }
                    },

                    "campaigns/:campaignId/schedules": {
                        callback: "showScheduleGalleryCampaign",
                        name: "EditCampaign",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.LE_EDIT_CAMPAIGNS]
                        }
                    },
                    "campaigns/:campaignId/schedules/select/:scheduleId": {
                        callback: "showScheduleGalleryCampaignSelect",
                        name: "EditCampaign",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.LE_EDIT_CAMPAIGNS]
                        }
                    },
                    "campaigns/:campaignId/schedules/edit/:scheduleId": {
                        callback: "showScheduleEditCampaign",
                        name: "EditCampaign",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.LE_EDIT_CAMPAIGNS]
                        }
                    },
                    "campaigns/:campaignId/schedules/edit/new": {
                        callback: "showScheduleNewCampaign",
                        name: "EditCampaign",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.LE_EDIT_CAMPAIGNS]
                        }
                    },
                    "campaigns/:campaignId/specialOccasions": {
                        callback: "showSpecialOccasionGalleryCampaign",
                        name: "EditCampaign",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.LE_EDIT_CAMPAIGNS]
                        }
                    },
                    "campaigns/:campaignId/specialOccasions/select/:specialOccasionId": {
                        callback: "showSpecialOccasionGalleryCampaignSelect",
                        name: "EditCampaign",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.LE_EDIT_CAMPAIGNS]
                        }
                    },
                    "campaigns/:campaignId/specialOccasions/edit/:specialOccasionId": {
                        callback: "showSpecialOccasionEditCampaign",
                        name: "EditCampaign",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.LE_EDIT_CAMPAIGNS]
                        }
                    },
                    "campaigns/:campaignId/specialOccasions/edit/new": {
                        callback: "showSpecialOccasionNewCampaign",
                        name: "EditCampaign",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.LE_EDIT_CAMPAIGNS]
                        }
                    }
                },
                defaultRoute: "",
                fallbackRoute: "LECampaigns"
            },

            initialize:function () {
                LEManager.logger.info("initialize","ManagerRouteController");

                this.dataSourcesTabsController = new DataSourcesTabsController();
                this.apiKeyEditController = new ApiKeyEditController();
                this.appKeysGalleryController = new AppKeysGalleryController();
                this.appKeyEditController = new AppKeyEditController();
                this.dataSourcesSdesController = new DataSourcesSdesController({});

                this.languageSettingsController = new LanguageSettingsController({});
                this.categoriesTableController = new CategoriesTableController({});
                this.LPTagController = new LPTagController({});
                this.manageDomainsController = new ManageDomainsController({});
                this.shiftStatusController = new ShiftStatusController({});
                this.myProfileController = new MyProfileController({managerController:this});

                this.scheduleControllers = {};
                _.each(ScheduleController.MODES, _.bind(function(mode) {
                    this.scheduleControllers[mode] = new ScheduleController({mode:mode});
                }, this));

                this.specialOccasionControllers = {};
                _.each(SpecialOccasionController.MODES, _.bind(function(mode) {
                    this.specialOccasionControllers[mode] = new SpecialOccasionController({mode:mode});
                }, this));


                if (LE.sessionManager.hasConversationSourcesFeature() || (LE.sessionManager.hasAsyncMessagingFeature() && LEConfig.c4mMobileApp)) {
                    _.extend(this.navigation.routes, {
                        "data/sources": {
                            callback: "showDataSourcesConversationSourcesTab",
                            name: "DataSourcesOpen",
                            hasSpecialNavigate: true,
                            auth: {
                                privileges: [LE.sessionManager.PRIVILEGES.VIEW_CONVERSATION_SOURCES]
                            }
                        }
                    });

                    if (LE.sessionManager.hasAsyncMessagingFeature() && LEConfig.c4mMobileApp) {
                        _.extend(this.navigation.routes, {
                            "data/sources/:softwareId/:appInstallId": {
                                callback: "showEditAppInstall",
                                name: "ShowEditAppInstall",
                                hasSpecialNavigate: true,
                                auth: {
                                    privileges: [LE.sessionManager.PRIVILEGES.CONFIGURE_CONVERSATION_SOURCES]
                                }
                            },
                            "data/sources/:softwareId/new": {
                                callback: "showNewAppInstall",
                                name: "ShowNewAppInstall",
                                hasSpecialNavigate: true,
                                auth: {
                                    privileges: [LE.sessionManager.PRIVILEGES.CONFIGURE_CONVERSATION_SOURCES]
                                }
                            }
                        });
                        this.appInstallEditController = new AppInstallEditController();
                    }

                    if (LE.sessionManager.hasConversationSourcesFeature()) {
                        _.extend(this.navigation.routes, {
                            "data/sources/twilio/activation": {
                                callback: "showTwilioActivation",
                                name: "TwilioActivation",
                                hasSpecialNavigate: true,
                                auth: {
                                    privileges: [LE.sessionManager.PRIVILEGES.CONFIGURE_CONVERSATION_SOURCES]
                                }
                            },
                            "data/sources/twilio/config": {
                                callback: "showTwilioConfig",
                                name: "TwilioConfig",
                                hasSpecialNavigate: true,
                                auth: {
                                    privileges: [LE.sessionManager.PRIVILEGES.CONFIGURE_CONVERSATION_SOURCES]
                                }
                            },
                            "data/sources/facebook/activation": {
                                callback: "showFacebookActivation",
                                name: "FacebookActivation",
                                hasSpecialNavigate: true,
                                auth: {
                                    privileges: [LE.sessionManager.PRIVILEGES.LE_VIEW_CAMPAIGN_MODULE]
                                }
                            },
                            "data/sources/facebook/config": {
                                callback: "showFacebookConfig",
                                name: "FacebookConfig",
                                hasSpecialNavigate: true,
                                auth: {
                                    privileges: [LE.sessionManager.PRIVILEGES.LE_VIEW_CAMPAIGN_MODULE]
                                }
                            },
                            "data/sources/brandApp/activation": {
                                callback: "showBrandAppActivation",
                                name: "BrandAppActivation",
                                hasSpecialNavigate: true,
                                auth: {
                                    privileges: [LE.sessionManager.PRIVILEGES.CONFIGURE_CONVERSATION_SOURCES]
                                }
                            }
                        });
                        this.facebookController = new FacebookController();
                        this.twilioController = new TwilioController();
                        this.brandAppController = new BrandAppController();
                    }
                }


                if (LE.sessionManager.hasAuditTrailFeature()) {
                    _.extend(this.navigation.routes, {
                        "audit": {
                            callback: "showAuditTrail",
                            name:"auditTrail",
                            hasSpecialNavigate: true,
                            auth: {
                                privileges: [LE.sessionManager.PRIVILEGES.VIEW_AUDIT_TRAIL]
                            }
                        }
                    });
                    this.auditTrailController = new AuditTrailController();
                }

                if (LE.sessionManager.hasAuthenticationChatFeature()) {
                    _.extend(this.navigation.routes, {
                        "data/integrations/authentication": {
                            callback: "showAuthenticationServer",
                            name: "AuthenticationServerOpen",
                            hasSpecialNavigate: true,
                            auth: {
                                privileges: [LE.sessionManager.PRIVILEGES.VIEW_AC_INTEGRATIONS_CONNECTORS]
                            }
                        }
                    });
                    this.authenticationServerController = new AuthenticationServerController();
                }

                this.navigation.defaultRoute = this.dataSourcesTabsController.getFirstTabPath();

                /*
                * if the active module is NOT LEManager, we do not want to let the corresponding LEManager DOM remain in the page.
                * Therefore we remove it by applying reset to the region.
                * There is a specific case where we should ignore the reset: when route is applied to a section in manager that is controlled by AC Feature.
                * */
                this.listenTo(LE.vent, "module:active", _.bind(function (options) {
                    if(options.moduleName !== LEManager.moduleName && options.moduleName !== LE.router.routerModule) {
                        this.getMainView().mainRegion.reset();
                    }
                }, this));
            },

            showDataSourcesConversationSourcesTab: function() {
                var connectorsCollection = LEManager.getModuleDataManager().getConnectorsCollection();
                var dependencies = [{name:LEManager.getModuleDataManager().getEntities().CONNECTORS, options:{isMandatory:true, fetchOptions: {urlParameters: connectorsCollection.URL_PARAMETERS.ACTIVATION}}}];

                if (LEConfig.c4mMobileApp) {
                    dependencies.push(
                        {name:LEManager.getModuleDataManager().getEntities().SOFTWARES, options:{isMandatory:true}},
                        {name:LEManager.getModuleDataManager().getEntities().APP_INSTALLS, options:{isMandatory:true}}
                    );
                }

                LEManager.getModuleDataManager().getDependencies({
                    dependencies: dependencies,
                    success: _.bind(function() {
                        LEManager.getMainRegion().add(this.dataSourcesTabsController.getView());
                        this.dataSourcesTabsController.showSourcesTab();
                    }, this)
                });
            },

            showDataSourcesIntegrationsTab: function() {
                LEManager.getModuleDataManager().getDependencies({
                    dependencies: [/* LEManager.getModuleDataManager().getEntities().SITE_SETTINGS_MY_DETAILS */],
                    success: _.bind(function() {
                        LEManager.getMainRegion().add(this.dataSourcesTabsController.getView());
                        this.dataSourcesTabsController.showIntegrationsTab();
                    }, this)
                });
            },

            showDataSourcesApiTab: function() {
                LEManager.getModuleDataManager().getDependencies({
                    dependencies: [{name: LEManager.getModuleDataManager().getEntities().API_KEYS, options:{isMandatory:true}}],
                    success: _.bind(function() {
                        LEManager.getMainRegion().add(this.dataSourcesTabsController.getView());
                        this.dataSourcesTabsController.showApiTab();
                    }, this)
                });
            },

            showApiKeyEdit: function(apiKeyId) {
                LEManager.getModuleDataManager().getDependencies({
                    dependencies: [{name:LEManager.getModuleDataManager().getEntities().API_FULL_LIST, options:{isMandatory:true}}],
                    success: _.bind(function() {
                        LEManager.getMainRegion().show(this.apiKeyEditController.getMainView());
                        this.apiKeyEditController.show(apiKeyId);
                    }, this)
                });
            },

            showApiKeyEditNew: function() {
                this.showApiKeyEdit(LE.CONST.ROUTING.NEW_ITEM_ID);
            },

            showAppKeysGallery: function() {
                LEManager.getModuleDataManager().getDependencies({
                    dependencies: [LEManager.getModuleDataManager().getEntities().APP_KEYS],
                    success: _.bind(function() {
                        LEManager.getMainRegion().add(this.appKeysGalleryController.getView());
                        this.appKeysGalleryController.show();
                    }, this)
                });
            },

            showAppKeyEdit: function(appKeyId) {
                LEManager.getMainRegion().add(this.appKeyEditController.getMainView());
                this.appKeyEditController.show(appKeyId);
            },

            showAuthenticationServer: function() {
                LEManager.logger.debug("authenticationServerOpen called" ,"ManagerRouteController:authenticationServerOpen");
                LEManager.getModuleDataManager().getDependencies({
                    dependencies: [{name:LEManager.getModuleDataManager().getEntities().AUTHENTICATION_SERVER, options:{isMandatory:true}}],
                    success: _.bind(function() {
                        LEManager.getMainRegion().add(this.authenticationServerController.getMainView());
                        this.authenticationServerController.show();
                    }, this)
                });
            },

            configureDataSource: function(rowId){
                LEManager.logger.debug("configureDataSource called " ,"ManagerRouteController:configureDataSource");
                LEManager.getMainRegion().add(this.dataSourcesSdesController.getMainView());
                this.dataSourcesSdesController.showDataSourceConfiguration({rowId: rowId});
            },
            configureDataSourcesAttribute: function(attributeId){
                LEManager.logger.debug("configureDataSourcesAttribute called " ,"ManagerRouteController:configureDataSourcesAttribute");
                LEManager.getMainRegion().add(this.dataSourcesSdesController.getMainView());
                this.dataSourcesSdesController.showDataSourceConfiguration({attributeId: attributeId});
            },
            languagesSettingsOpen: function() {
                LEManager.logger.debug("LanguagesSettingsOpen called" ,"ManagerRouteController:LanguagesSettingsOpen");
                LEManager.getMainRegion().add(this.languageSettingsController.getMainView());
                this.languageSettingsController.showLanguagesPage();
            },
            categoriesOpen: function() {
                LEManager.logger.debug("categoriesOpen called" ,"ManagerRouteController:categoriesOpen");
                LEManager.getMainRegion().add(this.categoriesTableController.getMainView());
                this.categoriesTableController.showCategoryList();
            },
            lptagOpen: function() {
                LEManager.logger.debug("lptagOpen called" ,"ManagerRouteController:lptagOpen");
                LEManager.getMainRegion().show(this.LPTagController.getMainView());
                this.LPTagController.showLPTagPage();
            },
            manageDomainsOpen: function() {
                LEManager.logger.debug("manageDomainsOpen called" ,"ManagerRouteController:manageDomainsOpen");
                LEManager.getMainRegion().show(this.manageDomainsController.getView());
                this.manageDomainsController.showManageDomainsPage();
            },
            myProfileOpen: function() {
                LEManager.logger.debug("myProfileOpen called" ,"ManagerRouteController:myProfileOpen");
                LEManager.getMainRegion().show(this.myProfileController.getMainView());
                this.myProfileController.show();
            },
            showShiftStatus: function(options) {
                LEManager.logger.debug("showShiftStatus called" ,"ManagerRouteController:showShiftStatus");
                LEManager.getModuleDataManager().getDependencies({
                    dependencies:[
                        {name:LEManager.getModuleDataManager().getEntities().SCHEDULES},
                        {name:LEManager.getModuleDataManager().getEntities().SPECIAL_OCCASIONS},
                        {name:LEManager.getModuleDataManager().getEntities().SITE_SETTINGS_MANUAL_SHIFT_STATUS}
                    ],
                    success: _.bind(function() {
                        LEManager.getMainRegion().show(this.shiftStatusController.getView());
                        this.shiftStatusController.show(options);
                    }, this)
                });
            },
            showAuditTrail: function() {
                LEManager.getMainRegion().show(this.auditTrailController.getMainView());
                this.auditTrailController.fetchData();
            },

            showNewAppInstall: function(softwareId){
                this.showEditAppInstall(softwareId, LE.CONST.ROUTING.NEW_ITEM_ID);
            },

            showEditAppInstall: function(softwareId, appInstallId){
                LEManager.getModuleDataManager().getDependencies({
                    dependencies: [{name:LEManager.getModuleDataManager().getEntities().SOFTWARES},
                        {name:LEManager.getModuleDataManager().getEntities().APP_INSTALLS}],
                    success: _.bind(function() {
                        LEManager.getMainRegion().add(this.appInstallEditController.getMainView());
                        this.appInstallEditController.showAppInstallEdit(softwareId, appInstallId);
                    }, this)
                });
            },
            showTwilioActivation: function(){
                var connectorsCollection = LEManager.getModuleDataManager().getConnectorsCollection();
                var fetchOptions = {
                    urlParameters: connectorsCollection.URL_PARAMETERS.ACTIVATION
                };

                LEManager.getModuleDataManager().getDependencies({
                    dependencies: [{name:LEManager.getModuleDataManager().getEntities().CONNECTORS, options:{fetchOptions:fetchOptions}}],
                    success: _.bind(function() {
                        LEManager.getMainRegion().add(this.twilioController.getMainView());
                        this.twilioController.showActivationView();
                    }, this)
                });
            },

            showTwilioConfig: function(){
                var connectorsCollection = LEManager.getModuleDataManager().getConnectorsCollection();
                var fetchOptions = {
                    urlParameters: connectorsCollection.URL_PARAMETERS.CONFIG
                };

                LEManager.getModuleDataManager().getDependencies({
                    dependencies: [{name:LEManager.getModuleDataManager().getEntities().CONNECTORS, options:{fetchOptions:fetchOptions}}],
                    success: _.bind(function() {
                        LEManager.getMainRegion().add(this.twilioController.getMainView());
                        this.twilioController.showConfigView();
                    }, this)
                });
            },

            showFacebookActivation: function(){
                var connectorsCollection = LEManager.getModuleDataManager().getData(LEManager.getModuleDataManager().getEntities().CONNECTORS);
                var fetchOptions = {
                    urlParameters: connectorsCollection.URL_PARAMETERS.ACTIVATION
                };

                LEManager.getModuleDataManager().getDependencies({
                    dependencies: [{name:LEManager.getModuleDataManager().getEntities().CONNECTORS, options:{fetchOptions:fetchOptions}}],
                    success: _.bind(function() {
                        LEManager.getMainRegion().add(this.facebookController.getMainView());
                        this.facebookController.showActivationView();
                    }, this)
                });
            },

            showFacebookConfig: function(){
                var connectorsCollection = LEManager.getModuleDataManager().getData(LEManager.getModuleDataManager().getEntities().CONNECTORS);
                var fetchOptions = {
                    urlParameters: connectorsCollection.URL_PARAMETERS.CONFIG
                };

                LEManager.getModuleDataManager().getDependencies({
                    dependencies: [{name:LEManager.getModuleDataManager().getEntities().CONNECTORS, options:{fetchOptions:fetchOptions}},
                        {name:LEManager.getModuleDataManager().getEntities().USERS},
                        {name:LEManager.getModuleDataManager().getEntities().PROFILES},
                        {name:LEManager.getModuleDataManager().getEntities().SITE_SETTINGS_AGENT_MANAGER}],
                    success: _.bind(function() {
                        LEManager.getMainRegion().add(this.facebookController.getMainView());
                        this.facebookController.showConfigView();
                    }, this)
                });
            },

            showBrandAppActivation: function(){
                LEManager.logger.debug("showBrandAppActivation called " ,"ManagerRouteController:showBrandAppActivation");
                LEManager.getMainRegion().add(this.brandAppController.getMainView());
                this.brandAppController.showActivationView();
            },

            showScheduleGalleryShiftStatus: function(){
                this.showScheduleGallery({
                    mode: ScheduleController.MODES.WORKING_HOURS_SITE
                });
            },
            showScheduleGalleryShiftStatusSelect: function(selectedItemId) {
                this.showScheduleGallery({
                    mode: ScheduleController.MODES.WORKING_HOURS_SITE,
                    selectedItemId: parseInt(selectedItemId, 10)
                });
            },
            showScheduleEditShiftStatus: function(scheduleId){
                this.showScheduleEdit({
                    mode: ScheduleController.MODES.WORKING_HOURS_SITE,
                    scheduleId: scheduleId
                });
            },
            showScheduleNewShiftStatus: function() {
                this.showScheduleEditShiftStatus(LE.CONST.ROUTING.NEW_ITEM_ID);
            },

            showSpecialOccasionGalleryShiftStatus: function(){
                this.showSpecialOccasionGallery({
                    mode: SpecialOccasionController.MODES.WORKING_HOURS_SITE
                });
            },
            showSpecialOccasionGalleryShiftStatusSelect: function(selectedItemId) {
                this.showSpecialOccasionGallery({
                    mode: SpecialOccasionController.MODES.WORKING_HOURS_SITE,
                    selectedItemId: parseInt(selectedItemId, 10)
                });
            },
            showSpecialOccasionEditShiftStatus: function(specialOccasionId){
                this.showSpecialOccasionEdit({
                    mode: SpecialOccasionController.MODES.WORKING_HOURS_SITE,
                    specialOccasionId: specialOccasionId
                });
            },
            showSpecialOccasionNewShiftStatus: function() {
                this.showSpecialOccasionEditShiftStatus(LE.CONST.ROUTING.NEW_ITEM_ID);
            },



            showScheduleGallerySkill: function(skillId){
                this.showScheduleGallery({
                    mode: ScheduleController.MODES.WORKING_HOURS_SKILL,
                    contextEntityId: skillId
                });
            },
            showScheduleGallerySkillSelect: function(skillId, selectedItemId) {
                this.showScheduleGallery({
                    mode: ScheduleController.MODES.WORKING_HOURS_SKILL,
                    selectedItemId: parseInt(selectedItemId, 10),
                    contextEntityId: skillId
                });
            },
            showScheduleEditSkill: function(skillId, scheduleId){
                this.showScheduleEdit({
                    mode: ScheduleController.MODES.WORKING_HOURS_SKILL,
                    scheduleId: scheduleId,
                    contextEntityId: skillId
                });
            },
            showScheduleNewSkill: function(skillId) {
                this.showScheduleEditSkill(skillId, LE.CONST.ROUTING.NEW_ITEM_ID);
            },

            showSpecialOccasionGallerySkill: function(skillId){
                this.showSpecialOccasionGallery({
                    mode: SpecialOccasionController.MODES.WORKING_HOURS_SKILL,
                    contextEntityId: skillId
                });
            },
            showSpecialOccasionGallerySkillSelect: function(skillId, selectedItemId) {
                this.showSpecialOccasionGallery({
                    mode: SpecialOccasionController.MODES.WORKING_HOURS_SKILL,
                    selectedItemId: parseInt(selectedItemId, 10),
                    contextEntityId: skillId
                });
            },
            showSpecialOccasionEditSkill: function(skillId, specialOccasionId){
                this.showSpecialOccasionEdit({
                    mode: SpecialOccasionController.MODES.WORKING_HOURS_SKILL,
                    specialOccasionId: specialOccasionId,
                    contextEntityId: skillId
                });
            },
            showSpecialOccasionNewSkill: function(skillId) {
                this.showSpecialOccasionEditSkill(skillId, LE.CONST.ROUTING.NEW_ITEM_ID);
            },


            showScheduleGalleryCampaign: function(campaignId){
                this.showScheduleGallery({
                    mode: ScheduleController.MODES.CAMPAIGN_SCHEDULING,
                    contextEntityId: campaignId
                });
            },
            showScheduleGalleryCampaignSelect: function(campaignId, selectedItemId) {
                this.showScheduleGallery({
                    mode: ScheduleController.MODES.CAMPAIGN_SCHEDULING,
                    selectedItemId: parseInt(selectedItemId, 10),
                    contextEntityId: campaignId
                });
            },
            showScheduleEditCampaign: function(campaignId, scheduleId){
                this.showScheduleEdit({
                    mode: ScheduleController.MODES.CAMPAIGN_SCHEDULING,
                    scheduleId: scheduleId,
                    contextEntityId: campaignId
                });
            },
            showScheduleNewCampaign: function(campaignId) {
                this.showScheduleEditCampaign(campaignId, LE.CONST.ROUTING.NEW_ITEM_ID);
            },

            showSpecialOccasionGalleryCampaign: function(campaignId){
                this.showSpecialOccasionGallery({
                    mode: SpecialOccasionController.MODES.CAMPAIGN_SCHEDULING,
                    contextEntityId: campaignId
                });
            },
            showSpecialOccasionGalleryCampaignSelect: function(campaignId, selectedItemId) {
                this.showSpecialOccasionGallery({
                    mode: SpecialOccasionController.MODES.CAMPAIGN_SCHEDULING,
                    selectedItemId: parseInt(selectedItemId, 10),
                    contextEntityId: campaignId
                });
            },
            showSpecialOccasionEditCampaign: function(campaignId, specialOccasionId){
                this.showSpecialOccasionEdit({
                    mode: SpecialOccasionController.MODES.CAMPAIGN_SCHEDULING,
                    specialOccasionId: specialOccasionId,
                    contextEntityId: campaignId
                });
            },
            showSpecialOccasionNewCampaign: function(campaignId) {
                this.showSpecialOccasionEditCampaign(campaignId, LE.CONST.ROUTING.NEW_ITEM_ID);
            },

            showScheduleGallery: function(options) {
                var controller = this.scheduleControllers[options.mode];
                var dependencies = [
                    {name:LEManager.getModuleDataManager().getEntities().SCHEDULES},
                    {name:LEManager.getModuleDataManager().getEntities().SKILLS}
                ];

                if (LEManager.getModuleDataManager().verifyCampaigns() && LEConfig.scheduledCampaigns) {
                    dependencies.push({name:LEManager.getModuleDataManager().getEntities().CAMPAIGNS});
                }
                if (LE.sessionManager.hasEntitiesTaggingByLobFeature() || LE.siteSettings.lobSettings.hasLobSettingEnabled()) {
                    dependencies.push({name:LEManager.getModuleDataManager().getEntities().LOBS});
                }

                LEManager.getModuleDataManager().getDependencies({
                    dependencies: dependencies,
                    success: _.bind(function() {
                        LEManager.getMainRegion().show(controller.getView());
                        controller.showScheduleGallery(options);
                    }, this)
                });
            },

            showScheduleEdit: function(options) {
                var controller = this.scheduleControllers[options.mode];
                var dependencies = [
                    {name:LEManager.getModuleDataManager().getEntities().SCHEDULES},
                    {name:LEManager.getModuleDataManager().getEntities().SKILLS}
                ];

                if (LEManager.getModuleDataManager().verifyCampaigns() && LEConfig.scheduledCampaigns) {
                    dependencies.push({name:LEManager.getModuleDataManager().getEntities().CAMPAIGNS});
                }
                if (LE.sessionManager.hasEntitiesTaggingByLobFeature() || LE.siteSettings.lobSettings.hasLobSettingEnabled()) {
                    dependencies.push({name:LEManager.getModuleDataManager().getEntities().LOBS});
                }

                LEManager.getModuleDataManager().getDependencies({
                    dependencies: dependencies,
                    success: _.bind(function() {
                        LEManager.getMainRegion().show(controller.getView());
                        controller.showScheduleEdit(options);
                    }, this)
                });
            },

            showSpecialOccasionGallery: function(options) {
                var controller = this.specialOccasionControllers[options.mode];
                var dependencies = [
                    {name:LEManager.getModuleDataManager().getEntities().SPECIAL_OCCASIONS},
                    {name:LEManager.getModuleDataManager().getEntities().SKILLS}
                ];
                if (LEManager.getModuleDataManager().verifyCampaigns() && LEConfig.scheduledCampaigns) {
                    dependencies.push({name:LEManager.getModuleDataManager().getEntities().CAMPAIGNS});
                }
                if (LE.sessionManager.hasEntitiesTaggingByLobFeature() || LE.siteSettings.lobSettings.hasLobSettingEnabled()) {
                    dependencies.push({name:LEManager.getModuleDataManager().getEntities().LOBS});
                }

                LEManager.getModuleDataManager().getDependencies({
                    dependencies: dependencies,
                    success: _.bind(function() {
                        LEManager.getMainRegion().show(controller.getView());
                        controller.showSpecialOccasionGallery(options);
                    }, this)
                });
            },

            showSpecialOccasionEdit: function(options) {
                var controller = this.specialOccasionControllers[options.mode];
                var dependencies = [
                    {name:LEManager.getModuleDataManager().getEntities().SPECIAL_OCCASIONS},
                    {name:LEManager.getModuleDataManager().getEntities().SKILLS}
                ];
                if (LEManager.getModuleDataManager().verifyCampaigns() && LEConfig.scheduledCampaigns) {
                    dependencies.push({name:LEManager.getModuleDataManager().getEntities().CAMPAIGNS});
                }
                if (LE.sessionManager.hasEntitiesTaggingByLobFeature() || LE.siteSettings.lobSettings.hasLobSettingEnabled()) {
                    dependencies.push({name:LEManager.getModuleDataManager().getEntities().LOBS});
                }

                LEManager.getModuleDataManager().getDependencies({
                    dependencies: dependencies,
                    success: _.bind(function() {
                        LEManager.getMainRegion().show(controller.getView());
                        controller.showSpecialOccasionEdit(options);
                    }, this)
                });
            },

            getMainView:function () {
                return LEManager.getMainView();
            }


        });
    });
    return ManagerRouteController;
});

